import classNames from "classnames"
import DatePicker from "legacy/DatePicker"
import { floatsOnly, isPresent } from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"
import { v4 as uuidv4 } from "uuid"

class FormGroup extends React.Component {
  constructor(props) {
    super(props)
    this.id = uuidv4()
    this.currencySymbol = window.currentMarina?.currencySymbol || "$"
  }

  input() {
    $(".op-large").remove() // this is to fix the issue of the 1Password extension making the textfield disappear by inserting its element and confusing react
    const input = this.props.inputType || "input"
    switch (input) {
      case "input":
        return (
          <input
            autoFocus={this.props.autoFocus}
            className="form-control"
            type="text"
            value={this.props.value ?? ""}
            name={this.props.name}
            id={this.id}
            aria-labelledby={this.props.ariaLabelledBy}
            pattern={this.props.pattern}
            onBlur={this.props.onBlur}
            onChange={this.props.onChange}
            disabled={this.props.disabled}
            required={this.props.required}
            placeholder={this.props.placeholder}
            autoComplete={this.props.autoComplete || "off"}
            style={this.props.customStyle}
          />
        )
      case "password":
        return (
          <input
            autoFocus={this.props.autoFocus}
            className="form-control"
            type="password"
            pattern={this.props.pattern}
            value={this.props.value ?? ""}
            name={this.props.name}
            id={this.id}
            aria-labelledby={this.props.ariaLabelledBy}
            onBlur={this.props.onBlur}
            onChange={this.props.onChange}
            disabled={this.props.disabled}
            placeholder={this.props.placeholder}
            autoComplete={this.props.autoComplete || "off"}
          />
        )
      case "textarea":
        return (
          <textarea
            autoFocus={this.props.autoFocus}
            className="form-control"
            type="text"
            rows={this.props.rows || 2}
            value={this.props.value ?? ""}
            name={this.props.name}
            id={this.id}
            aria-labelledby={this.props.ariaLabelledBy}
            onChange={this.props.onChange}
            disabled={this.props.disabled}
            placeholder={this.props.placeholder}
            autoComplete={this.props.autoComplete || "off"}
            maxLength={this.props.maxLength}
            style={this.props.customStyle}
          />
        )
      case "datepicker": {
        const hasDisplayValue = isPresent(this.props.displayValue)
        const disabledStyles = "bg-gray-100 border-gray-300 text-gray-600"
        return (
          <div className="relative">
            <div
              className={classNames(
                "absolute inset-0 flex items-center justify-center rounded pl-3",
                {
                  "text-transparent": !hasDisplayValue,
                  [disabledStyles]: this.props.disabled && hasDisplayValue,
                }
              )}
            >
              {this.props.displayValue}
            </div>
            <div className="form-control-with-icon">
              <i className="icon icon-calendar form-control-icon-left" />
              <DatePicker
                name={this.props.name}
                id={this.id}
                setParentState={this.props.onChange}
                value={this.props.value && moment(this.props.value).format("L")}
                startDate={
                  this.props.startDate &&
                  moment(this.props.startDate).format("L")
                }
                endDate={
                  this.props.endDate && moment(this.props.endDate).format("L")
                }
                orientation="top"
                disabled={this.props.disabled}
                placeholder={this.props.placeholder}
                className={classNames({
                  "bg-transparent text-transparent": hasDisplayValue,
                  [disabledStyles]: this.props.disabled && !hasDisplayValue,
                })}
              />
            </div>
          </div>
        )
      }
      case "select":
        return (
          <select
            className={
              this.props.className ? this.props.className : "form-control"
            }
            name={this.props.name}
            id={this.id}
            aria-labelledby={this.props.ariaLabelledBy}
            value={this.props.value ?? ""}
            onChange={this.props.onChange}
            disabled={this.props.disabled}
            style={this.props.customStyle}
          >
            {this.props.children}
          </select>
        )
      case "currency":
        return (
          <div className="form-control-with-icon">
            <span className="form-control-icon-left">
              {this.currencySymbol}
            </span>
            <input
              className="form-control"
              type="text"
              pattern={this.props.pattern}
              value={this.props.value ?? ""}
              name={this.props.name}
              id={this.id}
              aria-labelledby={this.props.ariaLabelledBy}
              onChange={this.handleFloatsOnly.bind(this)}
              disabled={this.props.disabled}
              placeholder={this.props.placeholder}
              autoComplete={this.props.autoComplete || "off"}
              style={this.props.customStyle}
            />
          </div>
        )
      case "feet":
        return (
          <div className="form-control-with-icon">
            <input
              className="form-control"
              type="text"
              pattern={this.props.pattern}
              value={this.props.value ?? ""}
              name={this.props.name}
              id={this.id}
              aria-labelledby={this.props.ariaLabelledBy}
              onChange={this.props.onChange}
              disabled={this.props.disabled}
              placeholder={this.props.placeholder}
              autoComplete={this.props.autoComplete || "off"}
              style={this.props.customStyle}
            />
            <span className="form-control-icon-right">ft</span>
          </div>
        )
      case "percentage":
        return (
          <div className="form-control-with-icon">
            <input
              className="form-control"
              type="text"
              pattern={this.props.pattern}
              value={this.props.value ?? ""}
              name={this.props.name}
              id={this.id}
              aria-labelledby={this.props.ariaLabelledBy}
              onChange={this.handleFloatsOnly.bind(this)}
              disabled={this.props.disabled}
              placeholder={this.props.placeholder}
              autoComplete={this.props.autoComplete || "off"}
              style={this.props.customStyle}
            />
            <span className="form-control-icon-right">%</span>
          </div>
        )
      case "text-icon":
        return (
          <div className="form-control-with-icon">
            <input
              className="form-control"
              type="text"
              value={this.props.value ?? ""}
              name={this.props.name}
              id={this.id}
              onChange={this.props.onChange}
              disabled={this.props.disabled}
              placeholder={this.props.placeholder}
              autoComplete={this.props.autoComplete || "off"}
              style={this.props.customStyle}
            />
            <span className="form-control-icon-right">
              {this.props.iconText && (
                <i className={`icon ${this.props.iconText}`} />
              )}
            </span>
          </div>
        )
      case "num-with-icon":
        return (
          <div className="form-control-with-icon">
            <input
              className="form-control"
              type="number"
              pattern={this.props.pattern}
              value={this.props.value ?? ""}
              name={this.props.name}
              id={this.id}
              onChange={this.props.onChange}
              disabled={this.props.disabled}
              aria-labelledby={this.props.ariaLabelledBy}
              placeholder={this.props.placeholder}
              min={this.props.min}
              max={this.props.max}
              autoComplete={this.props.autoComplete || "off"}
            />
            <span className="form-control-icon-right">
              {this.props.iconText && (
                <i className={`icon ${this.props.iconText}`} />
              )}
            </span>
          </div>
        )
      case "search":
        return (
          <div className="form-control-with-icon">
            <input
              className="form-control"
              type="text"
              pattern={this.props.pattern}
              value={this.props.value ?? ""}
              name={this.props.name}
              id={this.id}
              aria-labelledby={this.props.ariaLabelledBy}
              onChange={this.props.onChange}
              disabled={this.props.disabled}
              placeholder={this.props.placeholder}
              autoComplete={this.props.autoComplete || "off"}
              style={this.props.customStyle}
            />
            <span className="form-control-icon-right">
              {this.props.value && this.props.value.length > 0 && (
                <button
                  type="button"
                  className="bg-white"
                  aria-label="Reset Search"
                  onClick={this.props.resetSearch}
                >
                  <i className="icon icon-times" />
                </button>
              )}
            </span>
          </div>
        )
    }
  }

  handleFloatsOnly(event) {
    const scrubbedValue = floatsOnly(event.target.value)
    event.target.value = scrubbedValue
    this.props.onChange(event)
  }

  render() {
    if (this.props.inputType === "checkbox") {
      return (
        <div className={`checkbox ${this.props.className || ""}`}>
          {isPresent(this.props.ariaLabelledBy) ? (
            <input
              aria-labelledby={this.props.ariaLabelledBy}
              type="checkbox"
              name={this.props.name}
              checked={this.props.value}
              onChange={this.props.onChange}
              disabled={this.props.disabled}
              className="cursor-pointer"
            />
          ) : (
            <label className={this.props.labelClassName}>
              <input
                aria-labelledby={this.props.ariaLabelledBy}
                type="checkbox"
                name={this.props.name}
                checked={this.props.value}
                onChange={this.props.onChange}
                disabled={this.props.disabled}
                className="cursor-pointer"
              />
              {this.props.labelIcon && (
                <i
                  className={this.props.labelIcon}
                  data-toggle="tooltip"
                  data-placement="top"
                  title={this.props.labelIconTooltip}
                />
              )}
              {this.props.label}
            </label>
          )}
          {this.props.validation}
        </div>
      )
    } else {
      if (this.props.customLabelComponent) {
        return (
          <div className={`form-group ${this.props.className || ""}`}>
            <label className={this.props.labelClassName} htmlFor={this.id}>
              {this.props.customLabelComponent}
            </label>
            {this.input()}
            {this.props.validation}
          </div>
        )
      }
      return (
        <div className={`form-group ${this.props.className || ""}`}>
          {this.props.label && (
            <label className={this.props.labelClassName} htmlFor={this.id}>
              {this.props.labelImage && (
                <img
                  src={this.props.labelImage}
                  className="m-0 mr-1 h-6 w-6"
                  alt={this.props.labelImageAlt}
                />
              )}
              {this.props.label}
              {this.props.required && (
                <span className="text-danger bs-ml-1">*</span>
              )}
            </label>
          )}
          {this.props.labelIcon && (
            <i
              className={this.props.labelIcon}
              data-toggle="tooltip"
              data-placement="top"
              title={this.props.labelIconTooltip}
            />
          )}
          {this.props.subLabel && (
            <div className="text-muted mb-2">{this.props.subLabel}</div>
          )}
          {this.input()}
          {this.props.validation}
        </div>
      )
    }
  }
}

FormGroup.propTypes = {
  autoFocus: PropTypes.bool,
  inputType: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  customLabelComponent: PropTypes.element,
  labelClassName: PropTypes.string,
  className: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  pattern: PropTypes.string,
  required: PropTypes.bool,
  customStyle: PropTypes.object,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  children: PropTypes.node,
  displayValue: PropTypes.string,
  iconText: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  resetSearch: PropTypes.func,
  labelImage: PropTypes.string,
  labelImageAlt: PropTypes.string,
  labelIcon: PropTypes.string,
  labelIconTooltip: PropTypes.string,
  subLabel: PropTypes.string,
  validation: PropTypes.node,
  customValidation: PropTypes.node,
}

export default FormGroup
